export default __webpack_public_path__ + "static/media/Record_StopRecord.d03613b4.svg";